import { query, mutate, subscribe } from './api-consumer';

export default {
  async getAssetByNfcId(nfcId, redirectOn403Error) {
    return query('getAsset', { nfcId }, redirectOn403Error);
  },
  async getAssetByBleId(bleId, redirectOn403Error, includeLabelData = false) {
    return query('getAsset', { bleId, includeLabelData }, redirectOn403Error);
  },
  async getAsset(assetId, redirectOn403Error) {
    return query('getAsset', { id: assetId }, redirectOn403Error);
  },
  async getAssetLocations(nfcId, nextToken) {
    return query('getAssetLocations', { nfcId, limit: 200, nextToken });
  },
  async getAssetTemperatures(id, nextToken) {
    return query('getAssetTemperatures', { id, limit: 1000, nextToken });
  },
  async getAssets(
    organisationId,
    nextToken,
    searchTerm = '*',
    filters = null,
    sortOrder = null,
  ) {
    const filter = { quickFilters: ['IsNotSpace'] };
    if (filters !== null) {
      if (filters.selectedZoneId !== '') {
        filter.quickFilters.push('InSpaces');
        filter.spaceIds = filters.selectedZoneId;
      }
      if (filters.selectedFacilityId !== '') {
        filter.quickFilters.push('InFacilities');
        filter.facilityIds = filters.selectedFacilityId;
      }
      if (filters.selectedConsignmentId !== '') {
        filter.quickFilters.push('InConsignments');
        filter.consignmentIds = filters.selectedConsignmentId;
      }
    }
    return query('searchOrganisationAssets', {
      id: organisationId,
      searchTerm,
      nextToken,
      limit: 20,
      filter,
      sortOrder,
    });
  },
  async addAsset(organisationId, name, nfcId, location) {
    return mutate('addAssetToOrganisation', {
      organisationId,
      name,
      nfcId,
      location,
    });
  },
  async editAsset(assetId, name) {
    return mutate('editAsset', { id: assetId, name });
  },
  async removeAsset(organisationId, assetId) {
    return mutate('removeAssetFromOrganisation', { assetId, organisationId });
  },
  async addLabelToAsset(assetId, nfcId, location) {
    return mutate('addLabelToAsset', {
      assetId,
      nfcId,
      location,
      replaceExistingLabel: true,
    });
  },
  async addLabelTemperatureReadings(bleId, readings) {
    return mutate('addLabelTemperatureReadings', {
      bleId,
      readings,
    });
  },
  async removeLabelFromAsset(assetId, nfcId) {
    return mutate('removeLabelFromAsset', {
      assetId,
      nfcId,
    });
  },
  subscribeToAssetUpdates(assetId, callback, errorCallback) {
    return subscribe('subscribeToAssetInSpaces', { assetId }, callback, errorCallback);
  },
  async getAssetSpaceHistory(assetId, nextToken) {
    return query('getAssetSpaceHistory', { id: assetId, limit: 100, nextToken });
  },
  async getAssetFacilityHistory(assetId, nextToken) {
    return query('getAssetFacilityHistory', { id: assetId, limit: 100, nextToken });
  },
  async getAssetEvents(assetId, nextToken) {
    return query('getAssetEvents', { id: assetId, limit: 100, nextToken });
  },
};
